var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.674,
    height: 15.674,
    viewBox: "0 0 15.674 15.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-493 -500)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(493 500)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.837,0A7.837,7.837,0,1,1,0,7.837,7.837,7.837,0,0,1,7.837,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3965.046-15665.668l2.2,2.2,3.978-3.979",
    transform: "translate(-3467.297 16173.298)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniTick);
export default __webpack_public_path__ + "static/media/mini_tick.35acc66158e1622f8ff7d9c621941652.svg";
export { ForwardRef as ReactComponent };